"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SKILLJAR_LITE_HIDDEN_MENU_KEYS = void 0;
exports.hasExternalProperty = hasExternalProperty;
exports.hasTopicCount = hasTopicCount;
exports.hasVisibleTopicsCount = hasVisibleTopicsCount;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var SKILLJAR_LITE_HIDDEN_MENU_KEYS = ['community', 'knowledgeBase', 'ideation', 'productUpdates', 'event', 'group'];
/**
 * @deprecated Consider migrating to `@insided/shared/utils/categories` Category or CategoryLite structure
 */

exports.SKILLJAR_LITE_HIDDEN_MENU_KEYS = SKILLJAR_LITE_HIDDEN_MENU_KEYS;

function hasExternalProperty(category) {
  return category && (0, _typeof2.default)(category) === 'object' && 'external' in category;
}

function hasTopicCount(category) {
  return 'topicCount' in category;
}

function hasVisibleTopicsCount(category) {
  return 'visibleTopicsCount' in category;
}